import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row h-100" }
const _hoisted_3 = { class: "col-xl-6" }
const _hoisted_4 = { class: "headline-wrap" }
const _hoisted_5 = { class: "headline-inner" }
const _hoisted_6 = ["src"]

import TranslatedContent from './TranslatedContent.vue';
import { PropType } from 'vue';
import { Dictionary} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerHeadline',
  props: {
  logoUrl: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: __props.logoUrl,
              style: {"max-width":"clamp(25%, 350px, 100%)","margin-bottom":"4vh"},
              alt: "DSP"
            }, null, 8, _hoisted_6),
            _renderSlot(_ctx.$slots, "language-selector"),
            _renderSlot(_ctx.$slots, "translated-content")
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "video-player")
    ])
  ]))
}
}

})